export enum AppFeature {
	SHOW_RESULTS = 'SHOW_RESULTS',
	ASSESSMENT_USER_INPUT = 'ASSESSMENT_USER_INPUT',
	EDIT_CHECK_DATA = 'EDIT_CHECK_DATA',
	DEACTIVATE_CONSENT_FORWARDING_AND_RESULTS = 'DEACTIVATE_CONSENT_FORWARDING_AND_RESULTS',
	CONSENT_ADDITIONAL_1 = 'CONSENT_ADDITIONAL_1',
	CONSENT_ADDITIONAL_2 = 'CONSENT_ADDITIONAL_2',
	DOB = 'DOB',
	PLACE_OF_RESIDENCE = 'PLACE_OF_RESIDENCE'
}

export type SimpleAppFeature = Exclude<AppFeature, AppFeature.DOB | AppFeature.PLACE_OF_RESIDENCE>;
export type ComplexAppFeature = Extract<AppFeature, AppFeature.DOB | AppFeature.PLACE_OF_RESIDENCE>;

export interface SimpleFeature {
	name: SimpleAppFeature;
}

export interface DateOfBirthFeature {
	name: AppFeature.DOB;
	settings: {
		required: boolean;
		hidden: boolean;
	};
}

export interface PlaceOfResidenceFeature {
	name: AppFeature.PLACE_OF_RESIDENCE;
	settings: {
		required: boolean;
		hidden: boolean;
	};
}

export type ComplexFeature = DateOfBirthFeature | PlaceOfResidenceFeature;

export type Feature = SimpleFeature | ComplexFeature;

export type ComplexFeatureSettings<Feature extends ComplexAppFeature> = Extract<
	ComplexFeature,
	{
		name: Feature;
	}
>['settings'];

export const isComplexFeature = (feature: Feature): feature is ComplexFeature => {
	return 'settings' in feature;
};
